import NumberFlow from "@number-flow/react"
import { Flex, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import useAnimatedNumber from "../../../../hooks/useAnimatedNumber"
import Icon from "../../../../Icon"
import { STATUS_GROUP_META } from "../../constants/receipt-status-mapping"

import styles from "./styles.module.less"

const { Text } = Typography

export const ReceiptProgramCard = ({ id, name, iconType, value, status, isActive, onClick }) => {
  const { t } = useTranslation()
  const animatedValue = useAnimatedNumber(value)
  const meta = status && STATUS_GROUP_META?.[status]

  return (
    <Flex
      vertical
      justify="center"
      className={cls(styles.card, { [styles.cardActive]: isActive })}
      onClick={() => onClick(id)}
      role="button"
      tabIndex={0}
      data-testid={`deflect-user-program-card-${id}`}
    >
      <Flex align="center" gap={8} className={styles.header}>
        <Text strong className={styles.name}>
          {t(name)}
        </Text>
        {iconType && <Icon type={iconType} className={styles.icon} />}
      </Flex>

      <Flex justify="space-between" align="flex-end" gap={8} className={styles.footer}>
        <Text className={styles.value}>
          <NumberFlow value={animatedValue} format={{ maximumFractionDigits: 0 }} />
        </Text>
        {meta && (
          <Flex align="center" gap={6} className={styles.status}>
            <span className={styles.dot} style={{ backgroundColor: meta.hex }} />
            <Text style={{ color: meta.hex, fontSize: 12 }}>{t(meta.label)}</Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}
